import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Button from '../../../../components/Button';
import intl from 'react-intl-universal';

import './MapButtons.css';

@inject("appStore")
@observer
class MapButtons extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            locationIndex: 0,
        };
    }

    toMapPos = (viewport) => {
        this.props.appStore.setMapViewport({
            center: {
                lat: viewport.center[0],
                lng: viewport.center[1]
            },
            zoom: viewport.zoom
        });
        //this.props.appStore.map.element.setView(campusLoc.center, campusLoc.zoom);
    };

    zoomAction = (idx) => {
        let element = this.props.appStore.appConfig.map.zoomLocations[idx];
        if (this.props.appStore.isMobile) {
            this.props.appStore.toggleMBIconClick();
        }
        this.props.appStore.tracking.click('Zoom to Location', {
            defaultName: element.defaultName
        });
        this.toMapPos({center: [element.viewport.center.lat, element.viewport.center.lng], zoom: element.viewport.zoom});

        this.setState({ locationIndex: idx });
    };

    mobileIconClicked = () => {
        this.props.appStore.toggleMBIconClick();
    };

    changeBGColor = () => {
        if (this.props.appStore.isMBIconClicked) {
            return {backgroundColor: '#bfbfbf'};
        } else {
            return {};
        }
    };

    getInnerSideNav = () => {
        return (
            <div className="innerSideNav">
                <div className="zoom-to"><i className="far fa-compass" aria-hidden="true" /><p>{intl.get("MapContainer.mapButtonInfo")}</p></div>
                <ul>
                    {this.props.appStore.appConfig.map.zoomLocations.map((location, i) => (
                        <li
                            key={location.defaultName}
                            onClick={() => this.zoomAction(i)}
                            className={this.state.locationIndex === i ? 'selected' : ''}
                        >
                            {location.defaultName}
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    render() {
        if (this.props.appStore.isMobile) {
            return (
                <div className="MapButtonsM">
                    <div className="MBIcon">
                        <Button className='compassBtn' onClick={this.mobileIconClicked}
                                style={this.changeBGColor()}>
                            <i className="far fa-compass" aria-hidden="true"></i>
                        </Button>
                    </div>
                    {this.props.appStore.isMBIconClicked && this.getInnerSideNav()}
                </div>
            );
        } else {
            return (
                <div className="MapButtons">
                    {this.getInnerSideNav()}
                </div>
            );
        }

    }
}

export default MapButtons;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/MapButtons/index.js